/*
 * Algolia-powered search results page (Phase 2).
 * Fills the server-rendered shell (snippets/algolia-search-results.liquid):
 * queries Algolia for hits + facet counts, fetches each hit's real card HTML
 * from /products/<handle>?view=card (theme's own product-card markup), and
 * renders filters into the theme's drawer accordions. URL is the state:
 * ?q=..&page=..&sort_by=..&vendor=..&type=..&tag=.. (repeatable).
 */
(function () {
  var cfg = window.AlgoliaConfig;
  var root = document.querySelector('[data-algolia-search]');
  if (!cfg || !cfg.appId || !root) return;

  var searchConfig = JSON.parse(root.querySelector('[data-algolia-search-config]').textContent);
  var FACETS = searchConfig.facets;
  var STR = searchConfig.strings;
  var PER_PAGE = parseInt(root.getAttribute('data-per-page'), 10) || 24;
  var BASE_FILTER = root.getAttribute('data-base-filter') || '';

  var grid = root.querySelector('[data-algolia-grid]');
  var loading = root.querySelector('[data-algolia-loading]');
  var emptyState = root.querySelector('[data-algolia-empty]');
  var emptyText = root.querySelector('[data-algolia-empty-text]');
  var countEl = root.querySelector('[data-algolia-count]');
  var countShortEls = root.querySelectorAll('[data-algolia-count-short]');
  var filterCountEls = root.querySelectorAll('[data-algolia-filter-count]');
  var facetContainers = root.querySelectorAll('[data-algolia-facets]');
  var paginationEl = root.querySelector('[data-algolia-pagination]');
  var sortSelect = root.querySelector('[data-algolia-sort]');

  // '' on the primary locale, '/ar' on Arabic. Product URLs must carry it, or an
  // Arabic shopper clicking a result lands on the English page — and the card HTML
  // itself is rendered per-locale, so fetching it unprefixed returns English links.
  var ROOT = String(cfg.rootUrl || '/').replace(/\/+$/, '');
  function productUrl(handle) {
    return ROOT + '/products/' + encodeURIComponent(handle);
  }

  var cardCache = new Map(); // handle -> card HTML
  var openGroups = {}; // facet attr -> bool (accordion state across re-renders)
  FACETS.forEach(function (f) { openGroups[f.attr] = true; });
  var queryToken = 0;

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- state <-> URL ---------- */

  function readState() {
    var p = new URLSearchParams(window.location.search);
    var state = {
      q: p.get('q') || '',
      page: Math.max(1, parseInt(p.get('page'), 10) || 1),
      sort: p.get('sort_by') === 'best_selling' ? 'best_selling' : 'relevance',
      filters: {}
    };
    FACETS.forEach(function (f) {
      state.filters[f.attr] = p.getAll(f.param).filter(Boolean);
    });
    return state;
  }

  function writeState(state, push) {
    var p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (state.sort !== 'relevance') p.set('sort_by', state.sort);
    if (state.page > 1) p.set('page', String(state.page));
    FACETS.forEach(function (f) {
      state.filters[f.attr].forEach(function (v) { p.append(f.param, v); });
    });
    var url = window.location.pathname + (p.toString() ? '?' + p.toString() : '');
    if (push) history.pushState({ algolia: true }, '', url);
    else history.replaceState({ algolia: true }, '', url);
  }

  function activeFilterCount(state) {
    return FACETS.reduce(function (n, f) { return n + state.filters[f.attr].length; }, 0);
  }

  /* ---------- Algolia query ---------- */

  function indexFor(sort) {
    if (sort === 'best_selling') return cfg.index + '_recently_ordered_count_desc';
    return cfg.index;
  }

  function queryAlgolia(state) {
    var facetFilters = FACETS.map(function (f) {
      return state.filters[f.attr].map(function (v) { return f.attr + ':' + v; });
    }).filter(function (g) { return g.length; });
    if (BASE_FILTER) facetFilters.push(BASE_FILTER);

    var body = {
      query: state.q,
      page: state.page - 1,
      hitsPerPage: PER_PAGE,
      facets: FACETS.map(function (f) { return f.attr; }),
      maxValuesPerFacet: 25,
      attributesToRetrieve: ['title', 'handle', 'objectID'],
      attributesToHighlight: [],
      attributesToSnippet: [],
      distinct: true
    };
    if (facetFilters.length) body.facetFilters = facetFilters;

    return fetch(
      'https://' + cfg.appId + '-dsn.algolia.net/1/indexes/' +
        encodeURIComponent(indexFor(state.sort)) + '/query',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Algolia-Application-Id': cfg.appId,
          'X-Algolia-API-Key': cfg.apiKey
        },
        body: JSON.stringify(body)
      }
    ).then(function (r) { return r.json(); });
  }

  /* ---------- card fetching ---------- */

  function fetchCard(handle) {
    if (cardCache.has(handle)) return Promise.resolve(cardCache.get(handle));
    return fetch(productUrl(handle) + '?view=card')
      .then(function (r) {
        if (!r.ok) throw new Error('card ' + r.status);
        return r.text();
      })
      .then(function (html) {
        cardCache.set(handle, html);
        return html;
      })
      .catch(function () {
        var fallback =
          '<div class="card product-card product-card--card flex flex-col leading-none relative">' +
            '<div class="product-card__content grow flex flex-col justify-center p-4">' +
              '<a class="product-card__title reversed-link text-base-xl font-medium leading-tight" href="' +
                esc(productUrl(handle)) + '">' + esc(handle) + '</a>' +
            '</div></div>';
        cardCache.set(handle, fallback);
        return fallback;
      });
  }

  function fetchCards(handles) {
    var CONCURRENCY = 10;
    var queue = handles.slice();
    function worker() {
      if (!queue.length) return Promise.resolve();
      return fetchCard(queue.shift()).then(worker);
    }
    var workers = [];
    for (var i = 0; i < Math.min(CONCURRENCY, queue.length); i++) workers.push(worker());
    return Promise.all(workers);
  }

  /* ---------- rendering ---------- */

  function renderCount(nbHits, state) {
    var text = nbHits === 1
      ? STR.resultOne
      : STR.resultOther.replace('%COUNT%', nbHits.toLocaleString());
    if (countEl) countEl.textContent = text;
    countShortEls.forEach(function (el) {
      el.textContent = nbHits >= 25000 ? '25,000+' : nbHits.toLocaleString();
    });
    var n = activeFilterCount(state);
    filterCountEls.forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function facetGroupHtml(facet, values, selected, context) {
    var items = Object.keys(values).map(function (value, i) {
      var id = 'AlgoliaFacet-' + context + '-' + facet.attr + '-' + i;
      var checked = selected.indexOf(value) !== -1;
      return '<li class="flex items-center gap-3">' +
        '<input name="' + esc(facet.param) + '" value="' + esc(value) + '" class="checkbox" id="' + id + '" type="checkbox"' + (checked ? ' checked' : '') + ' />' +
        '<label for="' + id + '" class="flex items-baseline gap-1">' + esc(value) +
          '<span class="text-sm' + (checked ? '' : ' text-opacity') + '">(' + values[value].toLocaleString() + ')</span>' +
        '</label></li>';
    }).join('');

    // keep selected values visible even when Algolia omits them from top counts
    selected.forEach(function (value, j) {
      if (!(value in values)) {
        var id = 'AlgoliaFacetSel-' + context + '-' + facet.attr + '-' + j;
        items = '<li class="flex items-center gap-3">' +
          '<input name="' + esc(facet.param) + '" value="' + esc(value) + '" class="checkbox" id="' + id + '" type="checkbox" checked />' +
          '<label for="' + id + '" class="flex items-baseline gap-1">' + esc(value) + '</label></li>' + items;
      }
    });

    if (!items) return '';
    var open = openGroups[facet.attr];
    return '<details class="details' + (open ? ' active' : '') + '" is="accordion-details"' + (open ? ' open' : '') + ' data-algolia-group="' + esc(facet.attr) + '">' +
      '<summary class="details__summary flex items-center justify-between gap-2 cursor-pointer">' +
        '<span class="text-base-xl font-medium">' + esc(facet.label) + '</span>' +
        '<svg class="icon icon-chevron-up" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m6 15 6-6 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</summary>' +
      '<div class="details__content"><ul class="list grid gap-3" role="list">' + items + '</ul></div>' +
    '</details>';
  }

  function sortGroupHtml(state, context) {
    var items = (searchConfig.sorts || []).map(function (s, i) {
      var id = 'AlgoliaSort-' + context + '-' + i;
      return '<li class="flex items-center gap-3">' +
        '<input name="algolia-sort" value="' + esc(s.value) + '" class="checkbox" id="' + id + '" type="radio"' + (state.sort === s.value ? ' checked' : '') + ' />' +
        '<label for="' + id + '">' + esc(s.label) + '</label></li>';
    }).join('');
    var open = openGroups['algolia-sort'] !== false;
    return '<details class="details' + (open ? ' active' : '') + '" is="accordion-details"' + (open ? ' open' : '') + ' data-algolia-group="algolia-sort">' +
      '<summary class="details__summary flex items-center justify-between gap-2 cursor-pointer">' +
        '<span class="text-base-xl font-medium">' + esc(STR.sortBy || 'Sort by') + '</span>' +
        '<svg class="icon icon-chevron-up" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m6 15 6-6 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</summary>' +
      '<div class="details__content"><ul class="list grid gap-3" role="list">' + items + '</ul></div>' +
    '</details>';
  }

  function renderFacets(result, state) {
    var facetsData = result.facets || {};
    facetContainers.forEach(function (container) {
      var context = container.getAttribute('data-context');
      var html = sortGroupHtml(state, context);
      html += FACETS.map(function (f) {
        return facetGroupHtml(f, facetsData[f.attr] || {}, state.filters[f.attr], context);
      }).join('');
      if (activeFilterCount(state) > 0) {
        html += '<div class="details"><button type="button" class="link text-sm" data-algolia-clear>' + esc(STR.clearAll) + '</button></div>';
      }
      container.innerHTML = html;
    });
  }

  function renderPagination(result, state) {
    if (!paginationEl) return;
    var nbPages = result.nbPages || 0;
    if (nbPages <= 1) { paginationEl.innerHTML = ''; return; }

    var current = state.page;
    var parts = [];
    var window_ = 2;
    var pages = [];
    for (var i = 1; i <= nbPages; i++) {
      if (i === 1 || i === nbPages || Math.abs(i - current) <= window_) pages.push(i);
    }
    var last = 0;
    pages.forEach(function (i) {
      if (last && i - last > 1) parts.push('<span class="page flex items-center justify-center rounded-full">&hellip;</span>');
      if (i === current) {
        parts.push('<span class="page current flex items-center justify-center rounded-full pointer-events-none" aria-current="page">' + i + '</span>');
      } else {
        parts.push('<a class="page flex items-center justify-center rounded-full" href="#" data-algolia-page="' + i + '">' +
          '<span class="btn-text">' + i + '</span></a>');
      }
      last = i;
    });

    var prev = current > 1
      ? '<a class="previous flex items-center justify-center gap-2 font-medium" href="#" data-algolia-page="' + (current - 1) + '"><span class="btn-text">' + esc(STR.previous) + '</span></a>'
      : '';
    var next = current < nbPages
      ? '<a class="next flex items-center justify-center gap-2 font-medium" href="#" data-algolia-page="' + (current + 1) + '"><span class="btn-text">' + esc(STR.next) + '</span></a>'
      : '';

    paginationEl.innerHTML =
      '<div class="pagination flex flex-wrap justify-center align-self-center md:gap-2 text-sm md:text-base">' +
        prev + parts.join('') + next +
      '</div>';
  }

  function dedupeByHandle(hits) {
    var seen = {};
    return hits.filter(function (h) {
      if (!h.handle || seen[h.handle]) return false;
      seen[h.handle] = true;
      return true;
    });
  }

  function run(state, scroll) {
    var token = ++queryToken;
    if (loading) loading.hidden = false;
    grid.style.opacity = '0.4';

    queryAlgolia(state).then(function (result) {
      if (token !== queryToken) return;

      var hits = dedupeByHandle(result.hits || []);
      renderCount(result.nbHits || 0, state);
      renderFacets(result, state);
      renderPagination(result, state);

      if (!hits.length) {
        grid.innerHTML = '';
        grid.style.opacity = '';
        if (loading) loading.hidden = true;
        if (emptyState) {
          emptyState.hidden = false;
          if (emptyText) {
            emptyText.textContent = state.q
              ? STR.noResults.split('%TERMS%').join(state.q)
              : (activeFilterCount(state) > 0 ? STR.useFewerFilters : STR.noProducts);
          }
        }
        return;
      }
      if (emptyState) emptyState.hidden = true;

      var handles = hits.map(function (h) { return h.handle; });
      fetchCards(handles).then(function () {
        if (token !== queryToken) return;
        grid.innerHTML = handles.map(function (h) { return cardCache.get(h); }).join('');

        // Cards arrive with is="lazy-image", and the theme paints .media.loading > img
        // at opacity 0 until LazyImage clears it inside a requestIdleCallback — so the
        // LCP image on a collection page stayed invisible after its bytes had landed.
        // Removing the attribute is the load-bearing part: it is the only thing that
        // ever adds .loading, so with it gone no opacity rule applies.
        Array.prototype.slice.call(grid.querySelectorAll('img'), 0, 6).forEach(function (img, i) {
          img.removeAttribute('is');
          img.removeAttribute('loading');
          img.classList.remove('loading');
          var media = img.closest('.media');
          if (media) media.classList.remove('loading');
          if (i === 0) img.setAttribute('fetchpriority', 'high');
        });

        grid.style.opacity = '';
        if (loading) loading.hidden = true;
        if (scroll) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }).catch(function (err) {
      if (token !== queryToken) return;
      grid.style.opacity = '';
      if (loading) loading.hidden = true;
      console.error('[Algolia search]', err);
    });
  }

  /* ---------- events ---------- */

  var state = readState();
  // If server-rendered query differs (e.g. terms had wildcards), trust the URL.
  if (sortSelect) sortSelect.value = state.sort;

  // Delegate on document: the theme's drawer component re-parents the filter
  // drawers to <body>, outside our root container.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-algolia-facets] input[type="checkbox"]')) {
      var facet = FACETS.filter(function (f) { return f.param === t.name; })[0];
      if (!facet) return;
      var list = state.filters[facet.attr];
      if (t.checked) {
        if (list.indexOf(t.value) === -1) list.push(t.value);
      } else {
        state.filters[facet.attr] = list.filter(function (v) { return v !== t.value; });
      }
      state.page = 1;
      writeState(state, true);
      run(state, false);
    } else if (t === sortSelect || t.matches('[data-algolia-facets] input[name="algolia-sort"]')) {
      state.sort = t.value === 'best_selling' ? 'best_selling' : 'relevance';
      state.page = 1;
      if (sortSelect) sortSelect.value = state.sort;
      writeState(state, true);
      run(state, false);
    }
  });

  document.addEventListener('click', function (e) {
    var page = e.target.closest && e.target.closest('[data-algolia-page]');
    if (page) {
      e.preventDefault();
      state.page = parseInt(page.getAttribute('data-algolia-page'), 10) || 1;
      writeState(state, true);
      run(state, true);
      return;
    }
    var clear = e.target.closest && e.target.closest('[data-algolia-clear]');
    if (clear) {
      FACETS.forEach(function (f) { state.filters[f.attr] = []; });
      state.page = 1;
      writeState(state, true);
      run(state, false);
      return;
    }
    var group = e.target.closest && e.target.closest('summary');
    if (group) {
      var details = group.parentElement;
      var attr = details && details.getAttribute('data-algolia-group');
      if (attr) {
        // record post-toggle state (click fires before open flips)
        setTimeout(function () { openGroups[attr] = details.hasAttribute('open'); }, 0);
      }
    }
  });

  window.addEventListener('popstate', function () {
    state = readState();
    if (sortSelect) sortSelect.value = state.sort;
    run(state, false);
  });

  run(state, false);
})();
